import React from 'react';
import { CommonReadonly, ManifestationReadonly, ReadonlyVersionLanguage } from '@warehouse/title/core';
import { Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import ChipDisplay from '../../../../src/components/library/ChipDisplay';
import { getCustomGridSingleSelectOperators } from '../../../shared/ui/table/muix.adapter';
import LanguagesSpokenJson from '../../../../src/assets/json-administration-profiles/availableLanguageSpoken.json';
import platformSpecsJSON from '../../../../src/assets/json-administration-profiles/available-platform-specs/tenant-platform-specs.json';

export function PlatformSpecificationColumnDataGrid<T extends CommonReadonly>(): GridColDef<T, string> {
	return {
		headerName: 'Platform Specification',
		field: 'platformSpecification',
		editable: false,
		renderCell: (params) => {
			const platformSpecificationRow = params.row as ManifestationReadonly;
			return (
				<Typography style={{ display: 'flex', alignItems: 'center', height: '100%' }} variant="body2">
					{platformSpecificationRow.platformSpecification?.label || 'Unknown'}
				</Typography>
			);
		},
		minWidth: 280,
		flex: 1,
		valueOptions:
			platformSpecsJSON.map((platformSpec) => ({
				value: platformSpec.platformSpecUuid,
				label: platformSpec.audienceIdentification.label,
			})) || [],
		type: 'singleSelect',
		filterOperators: getCustomGridSingleSelectOperators(),
	};
}

export function AlidColumnDataGrid<T extends CommonReadonly>(): GridColDef<T, string> {
	return {
		headerName: 'ALID',
		field: 'alid',
		editable: false,
		minWidth: 130,
		flex: 0.5,
		renderCell: (params) => (
			<Typography sx={{ display: 'flex', alignItems: 'center', height: '100%' }} variant="body2">
				{params.value}
			</Typography>
		),
	};
}

export function VersionLanguagesColumnDataGrid<T extends CommonReadonly>(): GridColDef<
	T,
	ReadonlyVersionLanguage[] | null | undefined
> {
	return {
		headerName: 'Version Languages',
		field: 'versionLanguages',
		editable: false,
		minWidth: 150,
		flex: 0.5,
		renderCell: (params) => {
			// Calculate available width for ChipDisplay
			const padding = 80; // Account for cell padding
			const availableWidth = params.colDef.computedWidth ? params.colDef.computedWidth - padding : 170;

			return (
				<div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
					<ChipDisplay
						values={params.value ? params.value.map(({ label }) => label) : []}
						allowOverflow
						variant="default"
						horizontalPadding={0}
						width={availableWidth}
						height={26}
					/>
				</div>
			);
		},
		valueOptions:
			LanguagesSpokenJson.map((language) => ({
				value: language?.uuid,
				label: language?.label,
			})) || [],
		type: 'singleSelect',
		filterOperators: getCustomGridSingleSelectOperators(),
		resizable: true,
	};
}
